import { type FC, memo } from 'react';
import { useTranslation } from 'react-i18next';

import type { Category } from '@/api/games';
import { Button } from '@/components/buttons';

interface IViewAllButtonProps {
  categoryId: Category;
  totalCount: number;
}

/**
 * Button to view all games in a category
 */
export const ViewAllButton: FC<IViewAllButtonProps> = memo(
  ({ categoryId, totalCount }) => {
    const { t } = useTranslation('common');

    return (
      <Button
        autoPaddingHorizontal
        className="all-btn"
        data-testid="games-slider-view-all-button"
        id="gameCategoryButton"
        paddingX={8}
        to={`/games/${categoryId}#gamesSection`}
        whiteTransparent
        xSmall
      >
        {`${t('gameCategories.all')} ${totalCount}`}
      </Button>
    );
  }
);
